import React from "react";
import "./DuplicateVersion.css";
import DuplicateVersionForm from "../VersionForm/DuplicateVersionForm";

const DuplicateVersion = (props) => {
  return <DuplicateVersionForm></DuplicateVersionForm>;
};

export default DuplicateVersion;
